import { render, staticRenderFns } from "./FooterBlockList.vue?vue&type=template&id=1abe36e0"
import script from "./FooterBlockList.vue?vue&type=script&lang=js"
export * from "./FooterBlockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports